<template>
  <div class="casino-search-page search page-content">
    <casino-search-bar></casino-search-bar>
    <casino-search-result></casino-search-result>
  </div>
</template>

<script>
import CasinoSearchBar from '@/components/igaming/partials/casinoSearch/casinoSearchBar.vue'
import CasinoSearchResult from '@/components/igaming/partials/casinoSearch/casinoSearchResult.vue'
import Casino from '@/components/mixins/Casino'
import store from '@/store'
export default {
  name: 'casinoSearchPage',
  props: [],
  mixins: [
    Casino
  ],
  components: {
    CasinoSearchBar,
    CasinoSearchResult
  },
  data () {
    return {}
  },
  computed: {
    searchResults () {
      return store.getters['gap/getResults']
    }
  },
  methods: {},
  mounted () {}
}
</script>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoSearch/casinoSearchPage.vue